import serializeJavascript from 'serialize-javascript';

export function safelySerializeJSON(obj: any): string {
    try {
        return serializeJavascript(obj, {isJSON: true});
    } catch (e) {
        return '{}';
    }
}
